import * as React from 'react';
import { LanguageContext } from '../../../../../context/LanguageContext';
import ArquivoDoCardRespondidoIcon from '../../../../../assets/icons/arquivo-do-card-respondido-icon.svg';
import VisualizadorDeArquivos from '../../../../Shared/components/VisualizadorDeArquivos';
import { HttpService } from '../../../../Shared/HttpService';

interface IArquivoVigente {
    id: number;
    versao: any;
    datavencimento: string;
    empresasid: number;
    caminhovirtual: string;
}

interface IDocumentoProp {
    nome: string;
    arquivovigente: IArquivoVigente;
}

interface IProps {
    documento: IDocumentoProp;
    handleDownload: Function;
}

interface IState {
    visualizadorDeArquivoEstaAberto: boolean;
    file: IFile | null;
    blobsEIdParaMiniatura: IBlobEIdParaMiniatura | null;
}

interface IFile {
    url: string;
    type: string;
}

interface IBlobEIdParaMiniatura {
    id: number;
    blob: Blob;
    url: string;
}

export default class DocumentoComponenteImage extends React.Component<IProps, IState> {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            visualizadorDeArquivoEstaAberto: false,
            file: null,
            blobsEIdParaMiniatura: null
        }
    }

    apresentarVencimento = (dataVencimento) => {
        const dataAtual = new Date();
        const dataVencimentoFormatada = new Date(dataVencimento);
        if (dataVencimento == null) {
            return (
                <span className="text-muted text-right mb-0"  style={{ fontSize: '0.75rem' }}>
                    Não expira
                    <i className="bi bi-dash-circle-fill ml-2"></i>
                </span>
            );
        } else if (dataVencimentoFormatada < dataAtual) {
            return (
                <span className="text-danger text-right mb-0"  style={{ fontSize: '0.75rem' }}>
                    Vencido
                    <i className="bi bi-exclamation-diamond-fill ml-2"></i>
                </span>
            );
        } else if (dataVencimentoFormatada > dataAtual) {
            return (
                <span className="text-success text-right mb-0"  style={{ fontSize: '0.75rem' }}>
                    Vigente
                    <i className="bi bi-check-circle-fill ml-2"></i>
                </span>
            );
        }

        return null;
        
    };
    
    openViewer = async (arquivo) => {
        if (!arquivo) return;
        this.setState({ visualizadorDeArquivoEstaAberto: true });

        const urlRequest = `api/ArquivosApi/Visualizar/${arquivo.arquivoId}/${arquivo.empresaId}`;
        
        try {
            const response = await HttpService.fetch(urlRequest, { method: 'GET' });
            if (!response.ok) {
                throw new Error("Erro ao fazer download do arquivo");
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            this.setState({ file: { url, type: blob.type } });
        } catch (error) {
            console.log(error);
        }
    }
    
    addBlobEIdParaMiniatura = (id: number, arquivo: { arquivoId: number, empresaId: number }) => {
        const urlRequest = `api/ArquivosApi/Visualizar/${arquivo.arquivoId}/${arquivo.empresaId}`;
        HttpService.fetch(urlRequest, { method: 'GET' })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Erro ao fazer download do arquivo");
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                this.setState({ blobsEIdParaMiniatura: { id, blob, url } });
                
            })
            .catch(error => {
                console.log(error);
            });
    }

    componentDidMount() {
        // se for png ou jpg, adicionar o blob e id para miniatura
        const { documento } = this.props;
        const { arquivovigente } = documento;
        const arquivo = { arquivoId: arquivovigente.id, empresaId: arquivovigente.empresasid };
        this.addBlobEIdParaMiniatura(arquivovigente.id, arquivo);
    }

    render() {
        const { documento, handleDownload } = this.props;
        const { nome, arquivovigente } = documento;
        const { id, versao, datavencimento } = arquivovigente;
        return (
            <React.Fragment>
                <div className="btn-group mr-2 mt-2 w-100 h-100">
                    <div className='w-100 h-100'>
                        <div className="btn-group w-100 h-100">
                            <button
                                type="button"
                                className="btn ws-outline-white-to-blue-background d-flex align-items-end border w-100"
                                title={nome}
                                onClick={ () => this.openViewer({ arquivoId: arquivovigente.id, empresaId: arquivovigente.empresasid }) }
                                style={{ backgroundColor: 'white' }}
                            >
                                <div className='d-flex flex-column w-100'>
                                    <div className='p-2'>
                                    {
                                        this.state.blobsEIdParaMiniatura != null
                                            ?   (
                                                    <img
                                                        src={this.state.blobsEIdParaMiniatura.url}
                                                        alt="Imagem do arquivo"
                                                        style={{ width: 'auto', maxWidth: '100%', height: 'auto', maxHeight: '300px' }}
                                                    />
                                                )
                                            :   <React.Fragment>
                                                    <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                    }
                                    </div>
                                    <div className='d-flex w-100'>
                                        {/* <img src={ArquivoDoCardRespondidoIcon} alt="Ícone de arquivo do card respondido" /> */}
                                        <div className='d-flex flex-column align-itens-end w-100'>
                                            { this.apresentarVencimento(datavencimento) }
                                            {/* <span className='ml-3 text-left' style={{ fontSize: '0.875rem' }}>{ nome } { arquivovigente != null && id > 0 ? `(${this.context.getLanguageResource("version")}: ${versao}) ` : "" }</span> */}
                                        </div>

                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                {
                    this.state.visualizadorDeArquivoEstaAberto && (
                        <VisualizadorDeArquivos
                            fecharModal={() => this.setState({ visualizadorDeArquivoEstaAberto: false, file: null })}
                            tipo={this.state.file !== null ? this.state.file.type.split('/')[1] : null}
                            url={this.state.file !== null ? this.state.file.url : null}
                            extensao={arquivovigente.caminhovirtual.split('.')[arquivovigente.caminhovirtual.split('.').length - 1]}
                            impedirFechamentoAoClicarFora
                        />
                    )
                }
            </React.Fragment>
        );
    }
}
